import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface ErrorMessage{
  exceptionMessage:string;
  exceptionCode:string;
  exceptionTitle:string;
}

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css']
})
export class SnackbarComponent implements OnInit {


  private subscriptions: Subscription[] = [];

  message: any;
  type: any;
  durationInSeconds = 5;
  documentError = false;
  errorData: any;

  constructor(
    private snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private router: Router
  ) {}

  public dismissSnackbar(): void {
    this.snackBar.dismiss();
  }

  public isError() {
    return this.data.type.toLowerCase() === 'error';
  }

  public isSuccess() {
    return this.data.type.toLowerCase() === 'success';
  }

  public isServerError() {
    if (this.data.isServerError) {
      return this.data.isServerError;
    } else {
      return false;
    }
  }

  get serverError(): ErrorMessage {
    return this.data.serverError as ErrorMessage;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event:any) => event instanceof NavigationStart))
        .subscribe(res => {
          this.snackBar.dismiss();
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
